import { getIrrigationStatusColors } from 'App/Map/_utils/getIrrigationStatusColors'
import type { TIrrigationDeviceStatus } from 'App/Map/types'
import { translate } from 'i18n/i18n'
import { Z_INDEX_NO_DATA, Z_INDEX_OFF, Z_INDEX_ON } from './irrigationActivityConstants'

export const getIrrigationStatusReturn = (status: TIrrigationDeviceStatus) => {
  if (status === 'on') {
    return {
      baseZIndex: Z_INDEX_ON,
      children: translate.phrases.banyanApp('On'),
      getContainerCSS: () => getIrrigationStatusColors(status),
    }
  }

  if (status === 'off') {
    return {
      baseZIndex: Z_INDEX_OFF,
      children: translate.phrases.banyanApp('Off'),
      getContainerCSS: () => getIrrigationStatusColors(status),
    }
  }

  return {
    baseZIndex: Z_INDEX_NO_DATA,
    children: translate.phrases.templates('-'),
    getContainerCSS: () => getIrrigationStatusColors(status),
  }
}
